export const howItWorksSteps = [
  {
    number: '01',
    title: 'Connect',
    description: 'Integrate LoadAPI.io with a single API key. No complex setup, no long onboarding.',
    icon: 'ri-plug-line',
  },
  {
    number: '02',
    title: 'Filter',
    description: 'Query real-time loads by lane, rate, equipment type, weight, and pickup window.',
    icon: 'ri-filter-2-line',
  },
  {
    number: '03',
    title: 'Contact',
    description: 'Reach brokers and shippers directly. Close deals faster with verified contact info.',
    icon: 'ri-contacts-line',
  },
];

export const brokerShowcase = [
  {
    name: 'Echo Global Logistics',
    shortName: 'Echo',
    color: 'border-l-sky-500',
    bgPill: 'bg-sky-50 text-sky-600',
    description: 'One of North America\'s largest truckload brokers with extensive coverage across dry van, refrigerated, and flatbed.',
  },
  {
    name: 'C.H. Robinson',
    shortName: 'CHR',
    color: 'border-l-emerald-500',
    bgPill: 'bg-emerald-50 text-emerald-600',
    description: 'The world\'s largest logistics platform, connecting shippers and carriers with unmatched scale and technology.',
  },
  {
    name: 'RXO',
    shortName: 'RXO',
    color: 'border-l-amber-500',
    bgPill: 'bg-amber-50 text-amber-600',
    description: 'A leading provider of asset-light transportation solutions, spun from XPO with deep broker expertise.',
  },
  {
    name: 'Uber Freight',
    shortName: 'Uber',
    color: 'border-l-gray-900',
    bgPill: 'bg-gray-100 text-gray-900',
    description: 'Tech-forward freight brokerage leveraging Uber\'s platform intelligence to match loads with available capacity.',
  },
];

export const featurePreviews = [
  {
    title: 'Real-Time Listings',
    description: 'Access live load board data refreshed continuously from top brokers across North America.',
    icon: 'ri-refresh-line',
  },
  {
    title: 'Smart Filters',
    description: 'Filter by origin, destination, equipment, weight, rate, and pickup/delivery windows.',
    icon: 'ri-equalizer-line',
  },
  {
    title: 'Direct Contact',
    description: 'Get broker contact details, reference numbers, and booking links without leaving your workflow.',
    icon: 'ri-phone-line',
  },
  {
    title: 'Unified API',
    description: 'One integration, all load boards. Stop building scrapers for every broker platform.',
    icon: 'ri-code-box-line',
  },
];